import { Button } from "../ui/button";
import { motion } from "framer-motion";
import { Play, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();

  const handleJoinWaitlist = () => {
    navigate('/join-waitlist');
  };

  return (
    <section className="bg-hero pt-28 pb-16 md:pt-36 md:pb-24">
      <div className="container-narrow mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-4xl mx-auto"
        >
          {/* Social proof badge */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-secondary text-secondary-foreground text-sm font-medium mb-6"
          >
            <Sparkles className="w-4 h-4" />
            <span>Loved by Tally bookkeeping CA firms with multiple clients</span>
          </motion.div>

          {/* Headline */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-tight mb-6"
          >
            250 Tally entries in 5 minutes.{" "}
            <span className="text-gradient">Zero manual voucher typing.</span>
          </motion.h1>

          {/* Subhead */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto mb-8"
          >
            AccountsGenie turns bank statements and purchase invoices into balanced Tally vouchers. You approve, then Genie posts. Total control!
          </motion.p>

          {/* CTAs */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8"
          >
            <Button size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-6 text-base font-semibold" onClick={handleJoinWaitlist}>
              Be the First!
            </Button>
            <Button variant="outline" size="lg" className="px-8 py-6 text-base font-semibold gap-2" onClick={handleJoinWaitlist}>
              <Play className="w-4 h-4" />
              Watch 2-min Workflow
            </Button>
          </motion.div>

          {/* Trust badge */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            className="text-sm text-muted-foreground"
          >
            Data entries stay in your Tally.
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
